<template>
  <div class="overview-tile">
    <div
      v-for="(tile, index) in tiles"
      :key="index"
      :style="tileWrapperClass(index)"
    >
      <InfoStatus
        :textTitle="tile.title"
        :textValue="
          shouldConvertDataFormat(tile.title)
            ? convertDataFormate(tile.content, tile.title)
            : tile.content
        "
        :tooltipTitleText="tile.tooltip"
        :tooltipPosition="top"
        className="tile-styles"
        textValColor="white"
        :labelStyle="{ color: '#C4C4C4', fontSize: '12px', lineHeight: '18px' }"
      />
    </div>
  </div>
</template>

<script>
import InfoStatus from '@/rex-components/rex-info-stats.vue';
import { convertBytes, getDataInGB } from '@/utils/helper-function';

export default {
  components: { InfoStatus },
  name: 'AWSTile',
  props: {
    tiles: {
      type: Array,
      required: true,
    },
    numberOfRows: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    numberOfColumns() {
      return Math.ceil(this.tiles.length / this.numberOfRows);
    },
    numberOfTilesUnProperlyAligned() {
      return this.tiles.length % this.numberOfColumns;
    },
    numberOfTilesProperlyAligned() {
      return this.tiles.length - this.numberOfTilesUnProperlyAligned;
    },
  },
  methods: {
    getDataInGB,
    shouldConvertDataFormat(title) {
      return (
        title?.toLowerCase()?.includes('gb') ||
        title?.toLowerCase()?.includes('mb')
      );
    },
    extractUnitFromTitle(title) {
      const unitRegex = /(gb|mb|kb)/i;
      const match = title?.match(unitRegex);
      return match?.[1];
    },
    convertDataFormate(value, title) {
      const unit = this.extractUnitFromTitle(title);
      const convertedValue = convertBytes(value, unit);

      return `${convertedValue} ${unit}`;
    },
    tileWrapperClass(currentTileIndex) {
      if (!this.numberOfTilesUnProperlyAligned) {
        return {
          flex: `0 0 ${100 / this.numberOfColumns}%`,
          padding: '0.313rem',
        };
      }
      if (currentTileIndex + 1 <= this.numberOfTilesProperlyAligned) {
        return {
          flex: `0 0 ${100 / this.numberOfColumns}%`,
          padding: '0.313rem',
        };
      } else {
        return {
          flex: `0 0 ${100 / this.numberOfTilesUnProperlyAligned}%`,
          padding: '0.313rem',
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.overview-tile {
  width: 100%;
  @include flex-row-wrap;
}
.tile-content {
  color: white;
}

.tile-styles {
  height: 100%;
  background-color: $bg-dark-black;
  border-radius: 8px;
}

.tile-title-class {
  color: black;
}
</style>
